import { N12_03 } from "./N12_03";

export const N12_02 = {
  selectedValueColumn: "Region",
  selectedTitle: "District",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "District",
        binding: {
          data: {
            columns: [
              {
                name: "District",
                columnName: "DistrictName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Actual Visits",
                columnName: "Coverage",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Planned Visits",
                columnName: "Target",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Rate",
                columnName: "CallRate",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "DistrictName",
            endpoint: "SFE_N12.2",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "Region", value: "" }
            ],
          },
          context: {
            point: {
              onClick: N12_03,
            },
          },
        },
      },
    },
  ],
};